module.exports = __webpack_public_path__ + "static/media/kitchen-on-fire.e82d6764.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/kitchen-on-fire.gif
 ** module id = 672
 ** module chunks = 0
 **/